// eslint-disable-next-line no-shadow
enum Language {
  English = '1',
  Spanish = '2',
}

export default Language;
